import { Key, Entity } from '@briebug/ngrx-auto-entity';

@Entity({ modelName: 'MaterialCategory' })
export class MaterialCategory {
  @Key id?: number;
  name: string;
  delta: number;
}
